import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListSMTPSettings from '../../components/smtp/list-smtp-settings.component';

const SMTPSettingsView = () => {
  const pageTitle = 'Settings / Email Settings';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListSMTPSettings />
    </AppLayout>
  );
};

export default SMTPSettingsView;
